import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            width: '100%',
            textAlign: 'center',
        },
        content: {
            maxW: {base: '100%', lg: remCalc(1400)},
            mx: {base: 0, lg: 'auto'},
            pt: {base: remCalc(16), md: remCalc(24)},
            px: {base: remCalc(16), sm: remCalc(24), lg: 0},

            '.product-moodboard-swiper.desktop': {
                display: 'flex',
                flexDirection: ' column-reverse',
                gap: {base: remCalc(16), md: remCalc(24)},
            },
            '.swiper-pagination-bullet-active': {
                textTransform: 'uppercase',
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(4),
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                width: 'auto',
                height: 'auto',
                margin: `0 ${remCalc(13)}`,
                cursor: 'pointer',
            },

            '.img-container:hover img': {
                transform: 'scale(1.2)',
            },
            '.image-big': {
                maxW: {base: remCalc(311), sm: remCalc(250), md: remCalc(310), lg: remCalc(440)},
                maxH: {base: remCalc(250), sm: remCalc(250), md: remCalc(295), lg: remCalc(440)},
            },
            '.image-medium': {
                maxW: {base: remCalc(130), sm: remCalc(130), md: remCalc(178), lg: remCalc(266)},
                maxH: {base: remCalc(130), sm: remCalc(130), md: remCalc(178), lg: remCalc(266)},
            },
            '.image-small': {
                maxW: {base: remCalc(130), sm: remCalc(130), md: remCalc(110), lg: remCalc(164)},
                maxH: {base: remCalc(130), sm: remCalc(130), md: remCalc(100), lg: remCalc(164)},
            },
        },
        pagination: {
            justifyContent: 'center',
            zIndex: 1,
        },
        greybox: {
            overflow: 'hidden',
            bg: 'background.light',
            width: '100%',
            minHeight: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
        },
        imagecontainer: {
            position: 'relative',
            overflow: 'hidden',
        },
        imageoverlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        image: {
            transition: 'transform 0.7s ease-in-out',
        },
        textbox: {
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
}
